module.exports = __webpack_public_path__ + "static/img/brees-2015-slide-5.11d41e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-slide-5.jpg
// module id = ypNx
// module chunks = 1